import { browserSessionPersistence, getAuth, setPersistence } from 'firebase/auth';

import { logger } from '../../lib/telemetry/logger.js';

import { firebaseApp } from './app.js';

export const auth = getAuth(firebaseApp);

void setPersistence(auth, browserSessionPersistence).catch((error: unknown) => {
  logger.error(
    'firebase auth persistence failed; using in-memory',
    { source: 'firebase/auth' },
    error
  );
});
